export enum AnalogOutputMode {
	LowImpedance4Channels = 'LOW_IMPEDANCE_FOUR_CHANNELS',
	LowImpedance2Channels = 'LOW_IMPEDANCE_TWO_CHANNELS',
	SeventyVolt = 'SEVENTY_VOLT'
}

export enum AnalogLogicPreset {
	ModeA = 'MODE_A',
	ModeB = 'MODE_B'
}
